console.log(`
██╗      ██████╗  █████╗ ██████╗ ███████╗██████╗
██║     ██╔═══██╗██╔══██╗██╔══██╗██╔════╝██╔══██╗
██║     ██║   ██║███████║██║  ██║█████╗  ██║  ██║
██║     ██║   ██║██╔══██║██║  ██║██╔══╝  ██║  ██║
███████╗╚██████╔╝██║  ██║██████╔╝███████╗██████╔╝
╚══════╝ ╚═════╝ ╚═╝  ╚═╝╚═════╝ ╚══════╝╚═════╝
      `);

import gsap from '../../js/gsap/gsap.min.js';   
 
import { lenis } from '../../js/theme/_lenis.js'; 
 
( function () {
	var grid = document.querySelector( '[data-resources-grid]' );
	if ( ! grid ) {
		return;
	}

	var buttons = Array.prototype.slice.call( document.querySelectorAll( '[data-filter]' ) );
	var cards   = Array.prototype.slice.call( grid.querySelectorAll( '[data-category]' ) );

	function setState( filter ) {
		cards.forEach( function ( card ) {
			var matches = 'all' === filter || card.dataset.category === filter;
			card.classList.toggle( 'is-hidden', ! matches );
		} );
	}

	function applyFilter( filter ) {
	 
		if ( document.startViewTransition ) {
			document.startViewTransition( function () { setState( filter ); } );
		} else {
			setState( filter );
		}
	}

	buttons.forEach( function ( btn ) {
		btn.addEventListener( 'click', function () {
			buttons.forEach( function ( b ) { b.classList.remove( 'is-active' ); } );
			btn.classList.add( 'is-active' );
			applyFilter( btn.dataset.filter );
		} );
	} );
} )();


( function () {
	var toggle = document.querySelector( '[data-menu-toggle]' );
	var menu   = document.getElementById( 'site-menu' );
	if ( ! toggle || ! menu ) {
		return;
	}

	var closeBtn = menu.querySelector( '[data-menu-close]' );

	function openMenu() {
		menu.classList.add( 'is-open' );
		menu.setAttribute( 'aria-hidden', 'false' );
		document.body.classList.add( 'menu-open' );
		toggle.setAttribute( 'aria-expanded', 'true' );
		closeBtn.focus();
	}

	function closeMenu() {
		menu.classList.remove( 'is-open' );
		menu.setAttribute( 'aria-hidden', 'true' );
		document.body.classList.remove( 'menu-open' );
		toggle.setAttribute( 'aria-expanded', 'false' );
		toggle.focus();
	}

	toggle.addEventListener( 'click', openMenu );
	closeBtn.addEventListener( 'click', closeMenu );

	document.addEventListener( 'keydown', function ( e ) {
		if ( 'Escape' === e.key && menu.classList.contains( 'is-open' ) ) {
			closeMenu();
		}
	} );
} )();

( function () {
	var nav = document.querySelector( '.learning-nav' );
	if ( ! nav ) {
		return;
	}

	var toggle = nav.querySelector( '[data-learning-toggle]' );
	if ( ! toggle ) {
		return;
	}

	toggle.addEventListener( 'click', function () {
		var open = nav.classList.toggle( 'is-open' );
		toggle.setAttribute( 'aria-expanded', open ? 'true' : 'false' );
	} );

	document.addEventListener( 'click', function ( e ) {
		if ( ! nav.contains( e.target ) && nav.classList.contains( 'is-open' ) ) {
			nav.classList.remove( 'is-open' );
			toggle.setAttribute( 'aria-expanded', 'false' );
		}
	} );

	document.addEventListener( 'keydown', function ( e ) {
		if ( 'Escape' === e.key && nav.classList.contains( 'is-open' ) ) {
			nav.classList.remove( 'is-open' );
			toggle.setAttribute( 'aria-expanded', 'false' );
			toggle.focus();
		}
	} );
} )();
